import Axios from "axios";

let aiBaseURL = (process.env.VUE_APP_API_URL || "https://api.arboran.com.br/api/")
  .replace(/\/api\/$/, "/ai-service/api/v1");
if (process.env.NODE_ENV === "development") {
  aiBaseURL = "http://localhost:8000/api/v1";
}

const workshopHttp = Axios.create({ baseURL: aiBaseURL });
const local = JSON.parse(localStorage.getItem("user-token") || "null");
if (local && local.token) {
  workshopHttp.defaults.headers.common["Authorization"] = "bearer " + local.token;
}
workshopHttp.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("user-token");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

const publicHttp = Axios.create({ baseURL: aiBaseURL });

class WorkshopService {
  // ── Admin — Eventos ──────────────────────────────────────────────────────

  ListEvents(contaId) {
    return workshopHttp({ url: "/workshop/" + contaId, method: "GET" });
  }

  CreateEvent(contaId, data) {
    return workshopHttp({ url: "/workshop/" + contaId, data, method: "POST" });
  }

  GetEvent(eventId) {
    return workshopHttp({ url: "/workshop/events/" + eventId, method: "GET" });
  }

  UpdateEvent(eventId, data) {
    return workshopHttp({ url: "/workshop/events/" + eventId, data, method: "PUT" });
  }

  DeleteEvent(eventId) {
    return workshopHttp({ url: "/workshop/events/" + eventId, method: "DELETE" });
  }

  UpdateSchedule(eventId, schedule) {
    return workshopHttp({ url: "/workshop/events/" + eventId + "/schedule", data: { schedule }, method: "PUT" });
  }

  // ── Admin — Inscrições ───────────────────────────────────────────────────

  ListRegistrations(eventId, skip = 0, limit = 20, confirmedOnly = false) {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/registrations",
      method: "GET",
      params: { skip, limit, confirmed_only: confirmedOnly }
    });
  }

  ConfirmRegistration(eventId, regId) {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/registrations/" + regId + "/confirm",
      method: "PUT"
    });
  }

  DeleteRegistration(eventId, regId) {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/registrations/" + regId,
      method: "DELETE"
    });
  }

  ExportRegistrations(eventId) {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/registrations/export",
      method: "GET",
      responseType: "blob"
    });
  }

  // ── Admin — QR Code e Artwork ────────────────────────────────────────────

  GetQrCode(eventId, baseUrl, artworkType = "registration") {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/qrcode",
      method: "GET",
      params: { base_url: baseUrl, artwork_type: artworkType },
      responseType: "blob"
    });
  }

  GetDefaultPrompt(eventId, artworkType = "registration") {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/artwork/default-prompt",
      method: "GET",
      params: { artwork_type: artworkType }
    });
  }

  GenerateArtwork(eventId, prompt, quality, baseUrl, artworkType = "registration") {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/artwork/generate",
      data: { prompt: prompt || null, quality, base_url: baseUrl, artwork_type: artworkType },
      method: "POST"
    });
  }

  UploadArtwork(eventId, file, artworkType = "registration") {
    const formData = new FormData();
    formData.append("file", file);
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/artwork/upload",
      method: "POST",
      params: { artwork_type: artworkType },
      data: formData,
      headers: { "Content-Type": "multipart/form-data" }
    });
  }

  ListArtworks(eventId, artworkType = null) {
    const params = artworkType ? { artwork_type: artworkType } : {};
    return workshopHttp({ url: "/workshop/events/" + eventId + "/artwork", method: "GET", params });
  }

  DeleteArtwork(eventId, artworkId) {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/artwork/" + artworkId,
      method: "DELETE"
    });
  }

  // ── Admin — Fotos ────────────────────────────────────────────────────────

  UploadPhoto(eventId, file, caption) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("caption", caption);
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/photos",
      method: "POST",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" }
    });
  }

  ListPhotos(eventId) {
    return workshopHttp({ url: "/workshop/events/" + eventId + "/photos", method: "GET" });
  }

  UpdatePhoto(eventId, photoId, data) {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/photos/" + photoId,
      data,
      method: "PUT"
    });
  }

  DeletePhoto(eventId, photoId) {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/photos/" + photoId,
      method: "DELETE"
    });
  }

  DescribePhoto(eventId, photoId) {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/photos/" + photoId + "/describe",
      method: "POST"
    });
  }

  // ── Público (sem auth) ───────────────────────────────────────────────────

  GetPublicEvent(token) {
    return publicHttp({ url: "/public/workshop/" + token, method: "GET" });
  }

  Register(token, data) {
    return publicHttp({ url: "/public/workshop/" + token + "/register", data, method: "POST" });
  }

  Confirm(token, identifier) {
    return publicHttp({
      url: "/public/workshop/" + token + "/confirm",
      data: { identifier },
      method: "POST"
    });
  }
}

export default new WorkshopService();
